export const ModalRegistrarTrabajador = ({children, isOpen, closeModal}) => {

  const handleModalContainerClick = e => e.stopPropagation()
  
  return (
    <article className={`modal-registrar-trabajador ${isOpen && "is-open"}`} onClick={closeModal}>
      <div className="modal-container-registrar-trabajador" onClick={handleModalContainerClick}>
      <button className="modal-close-registrar-trabajador cancelButton" onClick={closeModal}>X</button>
        {children}
      </div>
    </article>
  )
}